export const GET_DASHBOARD_RECORD = "GET_DASHBOARD_RECORD";
export const GET_DASHBOARD_RECORD_SUCCESS = "GET_DASHBOARD_RECORD_SUCCESS";
export const GET_DASHBOARD_RECORD_ERROR = "GET_DASHBOARD_RECORD_ERROR";